module.exports = __webpack_public_path__ + "img/icon_more_white.ce5d6cb3.svg";